import React, {useContext, useState, useEffect} from "react";

// Import Css
import './planesCompt.css'

// Import Component
import { PlanesPreciosCompt } from './planesPreciosCompt'

//Import Assets
import IconIncluyeNO from '../../../assets/developAssets/icon-Incluye-no.svg'
import IconIncluyeSI from '../../../assets/developAssets/icon-Incluye-si.svg'


export function PlanesCompt() {

    return(

        <div className="container-all-planes-compt">

            <div className="box-title-subtitle-plan">
                <h2 className="title-plans">Un plan a la medida de tus necesidades</h2>
                <p className="subtitle-planes"> Solicita asesoria personalizada sin costo </p>
            </div>

            <div className="container-planes-precios">

                {/* Box plan precio */}
                <PlanesPreciosCompt 
                
                        titlePlan = 'Landing Page'
                        titleTextPlan = '1 página con secciones de información, links de contacto, portada y mini galería.'
                        textPrecio = '160.00'
                        textIncluye = 'Incluye diseño móvil adaptativo'
                        iconIncluye = {IconIncluyeNO}
                        textNoSiIncluye = 'No incluye hosting, dominio o email corporativo.'
                        colorClassName = 'colorYellow'
                
                />

                {/* Box plan precio */}
                <PlanesPreciosCompt 
                
                        titlePlan = 'Business Site'
                        titleTextPlan = 'Home + 3 sub páginas con secciones de información, funcionalidades, links de contacto, galería y portadas.'
                        textPrecio = '290.00'
                        textIncluye = 'Incluye diseño móvil adaptativo + SEO con IA + Google Analytics'
                        iconIncluye = {IconIncluyeNO}
                        textNoSiIncluye = 'No incluye hosting, dominio o email corporativo.'
                        colorClassName = 'colorAlpha'
                
                />

                {/* Box plan precio */}
                <PlanesPreciosCompt 
                
                        titlePlan = 'Web Pro'
                        titleTextPlan = 'Web a requerimiento del cliente con funcionalidades, galerías, portadas, animaciones y todo lo incluido en los planes base.'
                        textPrecio = '650.00'
                        textIncluye = 'Incluye diseño móvil adaptativo + SEO con IA + Google Analytics'
                        iconIncluye = {IconIncluyeSI}
                        textNoSiIncluye = 'Incluye hosting + dominio + 10 cuentas de mail corporativo.'
                        colorClassName = 'colorGreen'

                />

            
            </div>


        </div>

    );
}